import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportModal = ({
  show,
  reportError,
  hasReportedJob,
  selectedReason,
  reportSubmitting,
  checkingReport,
  onClose,
  onSubmit,
  onReasonChange
}) => {
  if (!show) return null;

  const reportReasons = [
    'Fraudulent or scam job posting',
    'Inappropriate content',
    'Misleading job description',
    'Discriminatory language',
    'Spam or duplicate posting',
    'Other'
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-lg max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-text-primary">Report Job</h3>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-secondary-100 rounded-lg transition-colors"
            disabled={reportSubmitting}
          >
            <Icon name="X" size={20} className="text-text-muted" />
          </button>
        </div>
        
        {reportError && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-800 text-sm">{reportError}</p>
          </div>
        )}

        {hasReportedJob && (
          <div className="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
            <div className="flex items-center">
              <Icon name="AlertTriangle" size={16} className="text-yellow-600 mr-2" />
              <p className="text-yellow-800 text-sm">
                You have already reported this job. Our team will review all reports.
              </p>
            </div>
          </div>
        )}
        
        <div className="mb-4">
          <p className="text-text-secondary mb-4">
            Help us keep VA Sprouts safe. Why are you reporting this job?
          </p>
          
          <div className="space-y-3">
            {reportReasons.map((reason) => (
              <label key={reason} className="flex items-center space-x-3 cursor-pointer">
                <input 
                  type="radio" 
                  name="reportReason" 
                  value={reason}
                  checked={selectedReason === reason}
                  onChange={(e) => onReasonChange(e.target.value)}
                  className="text-primary focus:ring-primary"
                  disabled={reportSubmitting}
                />
                <span className="text-text-secondary">{reason}</span>
              </label>
            ))}
          </div>
        </div>
        
        <div className="mb-6">
          <label className="block text-sm font-medium text-text-primary mb-2">
            Additional Details (Optional)
          </label>
          <textarea 
            id="reportDescription"
            className="w-full px-3 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
            rows="3"
            placeholder="Please provide more details about your report..."
            disabled={reportSubmitting}
          ></textarea>
        </div>
        
        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-border rounded-lg text-text-secondary hover:bg-secondary-50 transition-colors"
            disabled={reportSubmitting}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            disabled={reportSubmitting || !selectedReason.trim() || checkingReport}
          >
            {checkingReport ? (
              <>
                <Icon name="Loader2" size={16} className="mr-2 animate-spin" />
                Checking...
              </>
            ) : reportSubmitting ? (
              <>
                <Icon name="Loader2" size={16} className="mr-2 animate-spin" />
                Submitting...
              </>
            ) : hasReportedJob ? (
              'Submit Additional Report'
            ) : (
              'Submit Report'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;